import React from 'react'

export const renderAsHTML = (html, inline=false) => {
	const htmlText = {
		__html: html
	}
	return <div style={inline ? ({ display: 'inline' }) : ({})}dangerouslySetInnerHTML={htmlText} />
}
